
import { Button } from "@/components/ui/button";

interface NavigationButtonsProps {
  currentStep: number;
  canProceedToStep2: boolean;
  canProceedToStep3: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export function NavigationButtons({ 
  currentStep, 
  canProceedToStep2, 
  canProceedToStep3, 
  onPrevious, 
  onNext 
}: NavigationButtonsProps) {
  return (
    <div className="flex items-center justify-between">
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={currentStep === 1}
      >
        Previous
      </Button>
      
      {currentStep < 3 && (
        <Button
          onClick={onNext}
          disabled={
            (currentStep === 1 && !canProceedToStep2) ||
            (currentStep === 2 && !canProceedToStep3)
          }
        >
          Next
        </Button>
      )}
    </div>
  );
}
